import React from 'react';
import EditSeason from './EditSeason';

function ProfileEditSeasonPage() {
  return (
    <div className="row">
      <EditSeason />
    </div>
  );
}

export default ProfileEditSeasonPage;
